import React from 'react'
import Header from '../../components/application/notification/header'
import NotificationContent from '../../components/application/notification'

function Notification() {

  return (
    <>
      <Header/>
      <NotificationContent />
    </>
  )
}

export default Notification